<template>
  <div v-if="isFullScreenLoading" class="full-overlay">
    <span class="spinner-border text-light spinner-overlay" role="status" aria-hidden="true"></span>
  </div>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div class="card-head box-shadow bg-white">
      <div class="row px-3 py-2">
        <div class="mt-20 col-12 col-md-4">
          <form class="search-box position-relative">
            <input
              type="text"
              class="form-control shadow-none text-black rounded-0 border-0"
              placeholder="Search order"
              v-model="searchInput"
            />
            <button
              class="bg-transparent text-primary transition p-0 border-0"
              disabled
            >
              <i class="flaticon-search-interface-symbol"></i>
            </button>
          </form>
        </div>
        <div class="col row">
          <div class="col">
            <form>
              <label for="from-date" class="fw-medium">From</label>
              <input type="date" id="from-date" v-model="fromDate" class="form-control shadow-none text-black fs-md-15">
            </form>
          </div>
          <div class="col">
            <form>
              <label for="to-date" class="fw-medium">To</label>
              <input type="date" id="to-date" v-model="toDate" class="form-control shadow-none text-black fs-md-15">
            </form>
          </div>
          <!-- <div class="col">
            <form>
              <label for="status-select" class="fw-medium">Status </label>
              <select class="form-select shadow-none text-black fs-md-15" id="status-select" v-model="fulfillmentStatus">
                <option selected value="all" >All</option>
                <option v-for="fulfillmentStatusOption in fulfillmentStatuses" :key="fulfillmentStatusOption.id">{{ fulfillmentStatusOption.name }}</option>
              </select>
            </form>
          </div> -->
        </div>
      </div>
    </div>
    <!-- Existing template code -->
    <div class="card-body p-15 p-sm-20 p-md-25 position-relative">
      <div v-if="isLoading" class="relative-overlay">
        <span class="spinner-border text-light spinner-overlay" role="status" aria-hidden="true"></span>
      </div>
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                <SortableColumn column="order_number" :sortedBy="sortField" @sortClicked="sortClicked">Order #</SortableColumn>
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                <SortableColumn column="transaction_id" :sortedBy="sortField" @sortClicked="sortClicked">Transaction Id</SortableColumn>
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Channel Status
              </th>

              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                <SortableColumn column="customer_name" :sortedBy="sortField" defaultOrder='asc' @sortClicked="sortClicked">Customer Name</SortableColumn>
              </th>

              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Email
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                City
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                <SortableColumn column="channel_name" :sortedBy="sortField" defaultOrder='asc' @sortClicked="sortClicked">Channel</SortableColumn>
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                <SortableColumn column="created_at" :sortedBy="sortField" @sortClicked="sortClicked">Created at</SortableColumn>
              </th>
            </tr>
          </thead>

          <tbody v-if="orders.length">
            <tr v-for="order in orders" :key="order.id">
              <td><router-link :to="{ name: 'WholesaleOrderDetailsPage', params: { order_number: order.id } }">{{ order.id }}</router-link></td>
              <td>{{ order.marketplace_order_id }}</td>
              <td>{{ order.status }}</td>
              <td>{{ order.customer_name }}</td>
              <td>{{ order.customer_email }}</td>
              <td>{{ order.shipping_address.data.city }}</td>
              <td>{{ order.marketplace }}</td>
              <td>{{ formatTimestamp(order.created_at) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <PaginationFooter :pagination="meta.pagination" :sortField="sortField" :sortOrder="sortOrder" :search="searchInput" />
    </div>
  </div>
</template>

<script>
import { currentPage, formatTimestamp, getTodayDateSqlFormat, get7DaysAgoDateSqlFormat } from "../../utils/helper";
import SortableColumn from "../Common/SortableColumn.vue";
import PaginationFooter from "../Common/PaginationFooter.vue";
import apiConnector from '../../utils/apiConnector';

export default {
  name: "OrdersList",
  components: {
    SortableColumn,
    PaginationFooter
  },
  data() {
    return {
      isLoading: false,
      isFullScreenLoading: false,
      sortField: 'created_at',
      sortOrder: 'desc',
      fromDate: get7DaysAgoDateSqlFormat(),
      toDate: getTodayDateSqlFormat(),
      // fulfillmentStatus: null,
      orders: [],
      // fulfillmentStatuses: [
      //   {id: 1, name: 'Pending'},
      //   {id: 2, name: 'Picking'},
      //   {id: 3, name: 'QC Complete'},
      //   {id: 5, name: 'Shipped'},
      //   {id: 6, name: 'On Hold'},
      //   {id: 7, name: 'Cancelled'},
      //   {id: 8, name: 'Backordered'},
      //   {id: 9, name: 'Packed'},
      //   {id: 10, name: 'Pending PickUp'},
      //   {id: 12, name: 'Partially Shipped'},
      // ],
      searchInput: '',
      meta: {
        pagination: {
          total: 0,
          count: 0,
          per_page: 20,
          current_page: 1,
          total_pages: 1,
          links: {
            next: null,
            previous: null,
          },
        },
      },
    };
  },
  watch: {
    // Watch the entire route for changes in query parameters
    '$route.query': {
      immediate: true,
      handler(newQuery) {
        this.sortField = newQuery.sort_by || 'created_at';
        this.sortOrder = newQuery.sort_order || 'desc';
        this.searchInput = newQuery.q || '';
        this.fromDate = newQuery.from || get7DaysAgoDateSqlFormat();
        this.toDate = newQuery.to || getTodayDateSqlFormat();
        // this.fulfillmentStatus = newQuery.status || 'all';
        this.fetchOriginalWholesaleOrders();
      },
    },
    searchInput(){
      this.updatePageUrl();
    },
    fromDate(){
      this.updatePageUrl();
    },
    toDate(){
      this.updatePageUrl();
    },
  },
  methods: {
    async fetchOriginalWholesaleOrders() {
  
      this.isLoading = true;

      let url = `/merchant-wholesale-orders?&page=${currentPage()}&sorting[${this.sortField}]=${this.sortOrder}&filter[from]=${this.fromDate}&filter[to]=${this.toDate}`;

      // if (this.fulfillmentStatus != 'all') url += `&filter[fulfillment_status]=${encodeURIComponent(this.fulfillmentStatus)}`;
      if (this.searchInput) url += `&q=${encodeURIComponent(this.searchInput)}`;

      try {
        const response = await apiConnector.makeGetRequest(url);
        
        this.orders = response.data.data;
        this.meta = response.data.meta;

        // this.$router.replace({ path: this.$route.path, query: { q, page, 'filter[fulfillment_status]': fulfillmentStatus, sorting: { [this.sortField]: this.sortOrder } } }).catch(err => { console.log(err); });

      } catch (error) {
        console.error('There was an error fetching the orders:', error);
        this.orders = [];
        this.meta = { pagination: { total: 0, count: 0, current_page: 1, total_pages: 1, links: { next: null, previous: null } } };
      } finally {
        this.isLoading = false;
      }
    },

    sortClicked(sorting) {
      this.sortField = sorting.column;
      this.sortOrder = sorting.order;
      this.updatePageUrl();
    },

    updatePageUrl(page) {
      let query = {};
      if(page > 1){
        query.page = page;
      }
      if(this.sortField != 'created_at' || this.sortOrder != 'desc'){
        query.sort_by = this.sortField;
        query.sort_order = this.sortOrder;
      }
      if(this.fromDate != get7DaysAgoDateSqlFormat()){
        query.from = this.fromDate;
      }
      if(this.toDate != getTodayDateSqlFormat()){
        query.to = this.toDate;
      }
      // if(this.fulfillmentStatus != 'all'){
      //   query.status = this.fulfillmentStatus;
      // }
      if(this.searchInput){
        query.q = this.searchInput;
      }
      // console.log({ name: 'OrdersListPage', query: query });
      this.$router.replace({ name: 'WholesaleOrdersListPage', query: query }).catch(err => { console.log(err) });
    },
    formatTimestamp
  },
};
</script>
